/*
 * @Author: summer
 * @Date: 2019-08-07 13:32:42
 * @LastEditTime: 2025-04-10 12:22:58
 * @LastEditors: Please set LastEditors
 * @Description:
 */
/*
 *   查询区高级查询弹出框组件  --wangshhj
 * */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Resizable } from 're-resizable';
import {
    Button as NCButton,
    HotKeys as NCHotKeys,
    Dnd as NCDnd,
} from '@platform/base';
import SearchAdvCom from './SearchAdvCom';
import { getSysFieldid, microAppUtil } from '@platform/api';

require('./searchAdvModal.less');

export default class SearchAdvModal extends Component {
    constructor(props) {
        super(props);
        this.scrollContainer = microAppUtil.getPopContainer();
    }

    state = { position: null, resizeHeight:0, saveBtnDisable:!this.props.searchInfo.currentPlan.isMyPlan };

    closeMadol = e => {
        // 获取所有日期面板dom 并转化为数组
        const datePanels = Array.prototype.slice.call(
            document.querySelectorAll('.nc-date-picker-dropdown'),
            0,
        );
        // 只要有一个日期面板未关闭 则 hasDatePanel为true
        const hasDatePanel =
            datePanels.length > 0 &&
            datePanels.some(
                panel =>
                    getComputedStyle(panel).getPropertyValue('display') ===
                    'block',
            );
        let escKeyed = !!(document && hasDatePanel);
        //获取参照
        const referDom = document.querySelector('.refer-pop-window-show');
        if (
            e.keyCode == 27 &&
            !escKeyed &&
            this.props.searchInfo.showAdvModal &&
            referDom === null
        ) {
            this.cancelClick(e);
        }
    };
    componentDidMount() {
        document.body.addEventListener('keydown', this.closeMadol);
        this.props.getQueryScheme({ isAdvSearch: true });
    }
    componentWillUnmount() {
        document.body.removeEventListener('keydown', this.closeMadol);
    }
    // UNSAFE_componentWillReceiveProps(nextProps) {
    //     if (nextProps.searchInfo.currentPlan.isMyPlan != !this.state.saveBtnDisable) {
    //         this.setState({ saveBtnDisable:!nextProps.searchInfo.currentPlan.isMyPlan });
    //     }
    // }

    // 从新回到原来位置
    backPosition = () => {
        this.setState({ position: { x: 0, y: 0 } });
    };

    handStart = (a, b) => {
        this.setState({ position: { x: b.x, y: b.y } });
    };

    handleStop = (a, b) => {
        this.setState({ position: { x: b.x, y: b.y } });
    };
    getChildrenRef = ref => {
        if (ref) {
            this.savePlanFun = ref.saveSearchPlanClick;
            this.queryFun = ref.searchBtnClickEve;
            this.cancelClick = ref.cancelClick;
            this.addPlanFun = ref.addSearchPlanClick;
            this.sharePlanFun = ref.shareSearchPlanClick;
        }
    };
    saveBtnDisable = flag => {
        if(!flag !== this.state.saveBtnDisable){
            this.setState({ saveBtnDisable: !flag });
        }
        
    }
    repCloseModal = flag => {
        if (this.hasOwnProperty('prevOverFlow')) {
            this.scrollContainer.style.overflow = this.prevOverFlow;
            delete this.prevOverFlow;
        }
        this.props.closeModal(flag);
    }
    createBtn = () => {
        const { customAdvBtns } = this.props;
        const okDom = <div className="searchBtn search-btn-wrapper">
            <NCButton
                onClick={() => {
                    this.queryFun();
                }}
                colors="danger"
                fieldid="search"
                className="button-primary button-primary-wrapper "
            >
                {this.props.searchBtnName ||
               this.props. multiLang[
                   'page-search-0001'
               ]}
            </NCButton>
        </div>;
        const cancelDom = <div className="cancelBtn search-btn-wrapper">
            <NCButton
                onClick={() => {
                    this.cancelClick();
                }}
                shape="border"
                fieldid="cancel"
                className="secondary-button secondary-button-wrapper"
            >
                {this.props.multiLang['page-search-0010']}
            </NCButton>
        </div>;
        if(Array.isArray(customAdvBtns)){
            return <div className="searchBtnGroup">
                {customAdvBtns.map(item => {
                    const { key, label, callback } = item;
                    if(key === 'ok'){
                        return okDom; 
                    }else if(key === 'cancel'){
                        return cancelDom; 
                    }else{
                        return <div className="customBtn search-btn-wrapper">
                            <NCButton
                                onClick={callback}
                                shape="border"
                                fieldid={key}
                                className="secondary-button secondary-button-wrapper"
                            >
                                {label}
                            </NCButton>
                        </div>;
                    }
                })}
            </div>;

        }else{
            return <div className="searchBtnGroup">
                {okDom}
                {cancelDom}
            </div>;
        }
    }

    render() {
        let { multiLang, searchModalTitle, fieldid, moduleId, searchInfo, zIndex, advModalWidth = '1072px', advModalHeight = '525px'  } = this.props;
        // 业务组传入  title
        let title = searchModalTitle || multiLang['page-search-0025'];
        return ReactDOM.createPortal(
            <div
                // 给快捷键用
                id={`hot-key-modal-${moduleId}`}
                style={{ zIndex }}
                className={`NC_searchAdvModalBox ${this.props.className} search_${this.props.searchInfo.uniqueKey} search-${this.props.searchInfo.uniqueKey} search_${this.props.moduleId}`}
            >
                <div className="NC_searchAdvModalBackground">
                    <div
                        className="NC_searchAdvModal"
                        fieldid={
                            getSysFieldid(fieldid)
                                ? `${fieldid}-search_modal-area`
                                : 'search_modal-area'
                        }
                    >
                        <NCDnd
                            handle={`.super-handle-${this.props.searchInfo.uniqueKey}`}
                            cancel={`.super-cancel-${this.props.searchInfo.uniqueKey}`}
                            position={this.state.position}
                            // onStart = {this.handStart}
                            onStop={this.handleStop}
                            bounds={`.search_${this.props.searchInfo.uniqueKey}`}
                        >
                            {/* <Resizable
                                // bounds="window"
                                // onResize={this.onResize}
                                // onResizeStop={this.onResizeStop}
                                // onResizeStart={this.onResizeStart}
                                minWidth={1072}
                                minHeight={525}
                                // minHeight={max ? 520 : this.popover?.clientHeight}
                                defaultSize={{ width: 1072 ,height: 525}}
                                // className={`js-resize-container popover-shadow`}
                                // enable={{
                                //     top: true,
                                //     right: true,
                                //     bottom: true,
                                //     left: true,
                                //     topRight: false,
                                //     bottomRight: true,
                                //     bottomLeft: false,
                                //     topLeft: false,
                                // }}
                            > */}
                            <div className="NC_searchAdvModal_drag" style={{ width: advModalWidth, height: advModalHeight }}>
                                <div
                                    className={`modalHead super-handle-${this.props.searchInfo.uniqueKey}`}
                                    fieldid={getSysFieldid('header-area')}
                                >
                                    {/* <img src={require("../../static/images/modal-img.png")} className="modal-header-img" /> */}
                                    <span
                                        fieldid={getSysFieldid(
                                            `${title}_title`,
                                        )}
                                        className="modalTitle"
                                    >
                                        {title}
                                    </span>
                                    <div
                                        className={`closeBtn iconfont icon-guanbi super-cancel-${this.props.searchInfo.uniqueKey}`}
                                        onClick={() => {
                                            this.cancelClick();
                                        }}
                                        title="Esc"
                                    />
                                </div>
                                <SearchAdvCom
                                    ref={this.getChildrenRef}
                                    changePlanEve = {this.saveBtnDisable}
                                    {...this.props}
                                    closeModal={this.repCloseModal}
                                    backPosition={this.backPosition}
                                  
                                />
                                <div
                                    className="modalFooter"
                                    fieldid={getSysFieldid('bottom-area')}
                                >
                                    {this.props.showAdvSearchPlanBtn && (
                                        <div className="saveSearchPlan">
                                            <NCButton
                                                onClick={() => {
                                                    this.savePlanFun();
                                                }}
                                                shape="border"
                                                //colors="danger"
                                                disabled={this.state.saveBtnDisable}
                                                className="secondary-button secondary-button-wrapper footer-button-left"
                                                fieldid="savePlan"
                                            >
                                                {multiLang['page-search-0008']}
                                            </NCButton>
                                            <NCButton
                                                onClick={() => {
                                                    this.addPlanFun();
                                                }}
                                                shape="border"
                                                //colors="danger"//
                                                className="secondary-button secondary-button-wrapper footer-button-right"
                                                fieldid="addPlan"
                                            >
                                                {multiLang['page-search-0081']}
                                            </NCButton>
                                            {/* <NCButton
                                                    onClick={() => {
                                                        this.sharePlanFun();
                                                    }}
                                                    shape="border"
                                                    //colors="danger"//
                                                    className="secondary-button secondary-button-wrapper footer-button-right"
                                                    fieldid="sharePlan"
                                                >
                                                    {multiLang[
                                                        'page-search-0116'
                                                    ] || '查询方案管理'}
                                                </NCButton> */}
                                        </div>
                                    )}
                                    {this.createBtn()}
                                   
                                </div>
                            </div>
                            {/* </Resizable> */}
                        </NCDnd>
                    </div>
                </div>
            </div>,
            microAppUtil.getDocument(),
        );
    }
}
